import { queryOptions } from '@tanstack/react-query';

import { QUERY_STALE_TIME } from '@/constants/queryDefaults';

import { csvTableApi, type CsvTableQueryParams } from './csvTable.api';

export const csvTableOptions = {
  all: () => ['csv-table'] as const,

  data: ({ fileName, groupName, queryFileId, from }: CsvTableQueryParams) =>
    queryOptions({
      queryKey: [
        ...csvTableOptions.all(),
        'data',
        groupName,
        fileName,
        queryFileId ?? null,
        from ?? null
      ] as const,
      queryFn: () => csvTableApi.data({ fileName, groupName, queryFileId, from }),
      staleTime: QUERY_STALE_TIME.standard,
      retry: false,
      refetchOnWindowFocus: false
    })
};
